import angular from "angular";

import AdminDefinitionsModuleRouting from "./admin-definitions.module.routing";

export default angular
  .module("vt-admin-definitions", [])
  .config(AdminDefinitionsModuleRouting);
